import {ShapeOptions} from '@mui/system/createTheme/shape';

import {Tokens} from '../../../types/generated/Tokens';

export const shape = (borderTokens: Tokens['border']): ShapeOptions => ({
  corner: {
    desktop: {
      xsmall: borderTokens?.desktop.radius.xs || '',
      small: borderTokens.desktop.radius.sm,
      medium: borderTokens.desktop.radius.md,
      large: borderTokens.desktop.radius.lg,
      xlarge: borderTokens.desktop.radius.xl
    },
    mobile: {
      xsmall: borderTokens.mobile.radius.xs,
      small: borderTokens.mobile.radius.sm,
      medium: borderTokens.mobile.radius.md,
      large: borderTokens.mobile.radius.lg,
      xlarge: borderTokens.mobile.radius.xl
    }
  }
});
